<template>
  <div class="c-header-menu-item-desktop">
    <component
      :is="htmlTag"
      class="c-header-menu-item-desktop__main"
      v-bind="attributes"
      @click="onClick"
    >
      <img
        v-if="showImage && menuItem.image"
        class="c-header-menu-item-desktop__image"
        :src="menuItem.image"
      />
      <span v-else class="c-header-menu-item-desktop__image"></span>
      <h3 class="c-header-menu-item-desktop__title">
        {{ menuItem.title }}
      </h3>

      <span
        v-if="menuItem.items.length"
        class="c-header-menu-item-desktop__plus"
      >
        <span
          :class="['c-header-menu-item-desktop__vertical', { isAccordionOpen }]"
        ></span>
        <span class="c-header-menu-item-desktop__horizontal"></span>
      </span>
    </component>

    <template v-if="menuItem.items.length">
      <ul
        :class="['c-header-menu-item-desktop__children', { isAccordionOpen }]"
        :style="styleChildrenHeight"
      >
        <li
          v-for="childItem in menuItem.items"
          :key="childItem.url"
          ref="children"
        >
          <menu-item-desktop
            :menu-item="childItem"
            :show-image="childrenShowImage"
            @children-height-changed="onChildrenHeightChanged"
          ></menu-item-desktop>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import MenuItemDesktop from '~/js/components/header/menuItemDesktop'

export default {
  name: 'ComponentHeaderMenuItemDesktop',
  props: {
    menuItem: {
      type: Object,
      default: () => {
        return {}
      },
    },
    showImage: { type: Boolean, default: false },
  },
  components: {
    MenuItemDesktop,
  },
  computed: {
    attributes() {
      return this.menuItem.items.length
        ? { type: 'button' }
        : { href: this.menuItem.url }
    },
    childrenShowImage() {
      return this.menuItem.items.some((item) => !!item.image)
    },
    htmlTag() {
      return this.menuItem.items.length ? 'button' : 'a'
    },
    styleChildrenHeight() {
      return {
        height: this.isAccordionOpen ? `${this.childrenHeight}px` : 0,
      }
    },
  },
  data() {
    return {
      childrenHeight: 0,
      isAccordionOpen: false,
    }
  },
  methods: {
    onClick() {
      if (!this.$refs.children) return

      this.isAccordionOpen = !this.isAccordionOpen
      this.childrenHeight =
        this.$refs.children.reduce((sum, element) => {
          return sum + element.clientHeight
        }, 0) + 12
      const delta = this.isAccordionOpen
        ? this.childrenHeight
        : -1 * this.childrenHeight
      this.$emit('children-height-changed', { delta })
    },
    onChildrenHeightChanged({ delta }) {
      this.childrenHeight += delta
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-header-menu-item-desktop {
  &__main {
    align-items: center;
    display: flex;
    padding: 8px 0;
    transition: opacity 0.3s;

    @include mixins.screen-desktop {
      &:hover {
        opacity: 0.6;
      }
    }
  }

  &__image {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    object-fit: contain;
  }

  &__title {
    font-size: 12px;
    font-weight: 600;
    text-align: left;
  }

  &__children {
    padding-left: 24px;
    transition: 0.3s;
    overflow: hidden;
  }

  &__plus {
    width: 9px;
    height: 9px;
    position: relative;
    margin-left: 8px;
  }

  &__vertical,
  &__horizontal {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 9px;
    height: 1px;
    background-color: variables.$color-text;
  }

  &__vertical {
    transition: 0.3s;
    transform: rotate(90deg);

    &.isAccordionOpen {
      opacity: 0;
      transform: rotate(0deg);
    }
  }
}
</style>
